import { PaymentMethod } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
import { buyerPhoneSchema } from '../_shared/phone.js';
export const SessionPaymentType = {
    DEPOSIT: 'DEPOSIT',
    FULL: 'FULL',
};
export const billingAddressSchema = z.object({
    city: z.string().min(1),
    countryCode: z.string().min(1),
    // SSP rejects purely-numeric street names; require at least one letter so a
    // bare house number can never reach the provider.
    street: z.string().min(1).regex(/[A-Za-zÀ-ÿ]/, 'street must contain at least one letter'),
    zipCode: z.string().min(1),
});
/**
 * Paiement en plusieurs fois (INSTALLMENTS) : adresse de facturation requise.
 * Le choix 3x/4x se fait sur la page hébergée SSP, pas côté Massilia.
 */
export const initiateSessionCheckoutSchema = z
    .object({
    buyerEmail: z.string().optional(),
    billingAddress: billingAddressSchema.optional(),
    buyerPhone: buyerPhoneSchema.optional(),
    depositAmount: z.number().min(0).optional(),
    paymentMethod: z.nativeEnum(PaymentMethod),
    paymentType: z.nativeEnum(SessionPaymentType),
    subscribeToNotifications: z.boolean().optional(),
})
    .superRefine((data, ctx) => {
    if (data.paymentMethod === PaymentMethod.INSTALLMENTS && !data.billingAddress) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "L'adresse de facturation est requise pour le paiement en plusieurs fois.",
            path: ['billingAddress'],
        });
    }
});
